module.exports = __webpack_public_path__ + "static/media/deck-grid-4.f94359f8.webp";